// dashbaord
import Default from '../components/dashboard/default'
import { IndexWorkOrder } from '../views/admission/workOrder/IndexWorkOrder';
import { IndexCompanies } from '../views/catalog/companies/IndexCompanies';
import { IndexDoctors } from '../views/catalog/doctors/IndexDoctors';
import { IndexPatient } from '../views/catalog/patient/IndexPatient';
import { IndexBranch } from '../views/configuraciones/branches/IndexBranch';
import { IndexPrecodedText } from '../views/configuraciones/precodedTexts/IndexPrecodedText';
import { IndexUnit } from '../views/configuraciones/units/IndexUnit';
import { IndexPrices } from '../views/configuraciones/prices/IndexPrices';
import { IndexPrinterPoints } from '../views/configuraciones/printerPoints/IndexPrinterPoints';
import { IndexSpecimens } from '../views/configuraciones/specimens/IndexSpecimens';
import { IndexSections } from '../views/configuraciones/sections/IndexSections';
import { IndexExams } from '../views/disenio/exams/IndexExams';
import { IndexExamMethod } from '../views/disenio/exams/IndexExamMethod';
import { CreateOrUpdateAnalytes } from '../views/disenio/exams/CreateOrUpdateAnalytes';
import { IndexProfile } from '../views/disenio/profiles/IndexProfile';
import { IndexWorkOrderDay } from '../views/admission/viewWorkOrderDay/IndexWorkOrderDay';
import { IndexRates } from '../views/configuraciones/rates/IndexRates';
import { IndexWorkSheetsDay } from '../views/admission/viewWorkOrderDay/IndexWorkSheetsDay';
import { IndexCommercialLines } from '../views/configuraciones/commercialLines/IndexCommercialLines';
import { IndexPayMethods } from '../views/configuraciones/payMethods/IndexPayMethods';
import { IndexViewDetailWorkOrder } from '../views/admission/detailWorkOrder/IndexViewDetailWorkOrder';
import { IndexAddAgreement } from '../views/agreements/IndexAddAgreement';
import { IndexExamProductionCost } from '../views/disenio/exams/IndexExamProductionCost';
import { IndexSpecialDiscount } from '../views/discounts/IndexSpecialDiscount';
import { IndexCommonDiscount } from '../views/discounts/IndexCommonDiscount';
import { IndexAgreements } from '../views/configuraciones/agreements/IndexAgreements';
import { IndexLaboratories } from '../views/catalog/laboratoriesExternal/indexLaboratories'
import { IndexUpdateLaboratories } from '../views/catalog/laboratoriesExternal/IndexUpdateLaboratories';
import { IndexProfit } from '../views/configuraciones/profit/IndexProfit';
import { CaptureResultsFromNim } from '../views/admission/resultsCapture/CaptureResultsFromNim';
import { CaptureResultsFromNim as CaptureResultsFromNimMicro } from '../views/admission/resultsCaptureSanitaria/CaptureResultsFromNim';
import { IndexReturnReason } from '../views/configuraciones/returnReason/IndexReturnReason';
import { IndexAnalytes } from '../views/disenio/analytes/IndexAnalytes';
import { CreateExamSimple } from '../views/disenio/exams/CreateExamSimple';
import { IndexPriceExam } from '../views/disenio/profiles/IndexPriceExam';
import { IndexQuoter } from '../views/quoter/indexQuoter'
import { IndexUser } from '../views/configuraciones/users/IndexUser';
import { IndexIndications } from '../views/configuraciones/indications/IndexIndications';
import { CostsProfile } from '../views/disenio/profiles/CostsProfile';
import { GlobalReferenceValues } from '../views/disenio/profiles/GlobalReferenceValuesProfile';
import { IndexCost } from '../views/configuraciones/prices/IndexCost'
import { IndexAnalyzerInterface } from '../views/configuraciones/analyzerInterface/IndexAnalyzerInterface';
import { IndexInformedConsent } from '../views/InformedConsent/IndexInformedConsent';
import { IndexSeller } from '../views/catalog/seller/IndexSeller';
import { IndexBacter } from '../views/micro/catalogos/IndexBacter';
import { IndexMorphology } from '../views/micro/catalogos/IndexMorphology';
import { Indexlog } from '../views/configuraciones/logss/Indexlog';
import { IndexAntibiotic } from '../views/micro/catalogos/IndexAntibiotic';
import { IndexAntibiogram } from '../views/micro/catalogos/IndexAntibiogram';
import { IndexTabMenuQuoter } from '../views/micro/cotizacion/IndexTabMenuQuoter';
import { IndexResistanceMechanism } from '../views/micro/catalogos/IndexResistanceMechanism';
import { IndexStainGrams } from '../views/micro/catalogos/IndexStainGrams';
import { IndexBacteriumCountText } from '../views/micro/catalogos/IndexBacteriumCountText';
import { IndexStain } from '../views/micro/catalogos/IndexStain';
import { IndexStainResults } from '../views/micro/catalogos/IndexStainResults';
import { IndexReportMicStatistics } from '../views/micro/reports/IndexReportMicStatistics';
import { IndexMicroQuoter } from '../views/sanitary/microQuote/indexMicroQuoter';
import { IndexListSampligs } from '../views/sanitary/micSampling/IndexListSampligs';
import { IndexListMachinesSanitary } from '../views/sanitary/worksheets/IndexListMachinesSanitary';
import { IndexListLot } from '../views/sanitary/worksheets/IndexListLot';
import { IndexWorkSheetSanitary } from '../views/sanitary/worksheets/IndexWorkSheetSanitary';
import { IndexCaptureWorkSheetSanitary } from '../views/sanitary/worksheets/IndexCaptureWorkSheetSanitary';
import { IndexCreateWorkSheetSaniray } from '../views/sanitary/worksheets/IndexCreateWorkSheetSaniray';
import { CreateWSProcess } from '../views/sanitary/worksheets/CreateWSProcess';
import { IndexCulture } from '../views/micro/catalogos/IndexCulture';
import { CreateExam } from '../views/micro/disenio/exams/CreateExam';
import { IndexTransportsRacks } from '../views/transports/IndexTransportsRacks';
import { IndexCurvesTimes } from '../views/configuraciones/curvesTimes/IndexCurvesTimes';
import { IndexExamsMicrobiology } from '../views/micro/disenio/exams/IndexExamsMicrobiology';
import { IndexExamProductionCostMicrobiology } from '../views/micro/disenio/exams/IndexExamProductionCostMicrobiology';
import { IndexExamMethodMicrobiology } from '../views/micro/disenio/exams/IndexExamMethodMicrobiology';
import { IndexSatisfaction } from '../views/survey/IndexSatisfaction';
import { IndexCash } from '../views/cash/IndexCash';
import { IndexUserRole } from '../views/configuraciones/usersRoles/IndexUserRole';
import { IndexDoubleValidation } from '../views/admission/processExam/IndexDoubleValidation';
import { IndexConfigExams } from '../views/configuraciones/maquilaInterna/IndexConfigExams';
import { IndexPbi1 } from '../views/admission/Bi/IndexPbi1';
import { IndexPbi2 } from '../views/admission/Bi/IndexPbi2';
import { IndexPbi3 } from '../views/admission/Bi/IndexPbi3';
import { IndexPbi4 } from '../views/admission/Bi/IndexPbi4';
import { IndexPbi5 } from '../views/admission/Bi/IndexPbi5';
import { IndexPbi6 } from '../views/admission/Bi/IndexPbi6';
import { IndexPbi7 } from '../views/admission/Bi/IndexPbi7';
import { IndexPbi8 } from '../views/admission/Bi/IndexPbi8';
import { IndexPbi9 } from '../views/admission/Bi/IndexPbi9';
import { InvoiceSettings } from '../views/configuraciones/commercialLines/InvoiceSettings';
import { IndexInvoiceService } from '../views/invoice/IndexInvoiceService';
import { IndexSites } from '../views/sanitary/sites/IndexSites';
import { IndexMicSample } from "../views/sanitary/micSample/IndexMicSample";
import { IndexMicSiteArea } from "../views/sanitary/micSiteArea/IndexMicSiteArea";
import { IndexTypeSample } from "../views/sanitary/typeSample/IndexTypeSample";
import { IndexCashFlowGlobal } from '../views/cash/IndexCashFlowGlobal';
import { IndexMicSampling } from '../views/sanitary/micSampling/IndexMicSampling';
import { IndexMicDiary } from '../views/sanitary/micSampling/IndexMicDiary';
import { IndexViewInvoice } from '../views/invoice/IndexViewInvoice';
import { IndexMicCatalogs } from '../views/sanitary/micCatalogs/IndexMicCatalogs';
import { IndexReportsSanitary } from '../views/sanitary/micReports/IndexReportsSanitary';
import { IndexSampleReception } from '../views/sanitary/micReception/IndexSampleReception';
import { IndexMicContainers } from '../views/sanitary/micContainers/IndexMicContainers';
import { IndexMicEstatus } from '../views/sanitary/micEstatus/IndexMicEstatus';
import { IndexMicReturnReasons } from '../views/sanitary/micReturnReasons/IndexMicReturnReasons';
import { IndexMicUnits } from '../views/sanitary/micUnits/IndexMicUnits';
import { IndexMicThermometer } from '../views/sanitary/micThermometer/IndexMicThermometer';
import { IndexMicCharacteristic } from '../views/sanitary/micCharacteristic/IndexMicCharacteristic';
import { IndexInvoiceReport } from '../views/invoice/IndexInvoiceReport';
import { IndexReportCxc } from '../views/reports/cxc/IndexReportCxc';
import { IndexBankingDeposits } from '../views/invoice/IndexBankingDeposits';
import { IndexViewCalender } from '../views/SerieB/IndexViewCalender';
import { IndexCatalogsDiscounts } from '../views/discounts/IndexCatalogsDiscounts';
import { IndexComplementPaymentService } from '../views/invoice/IndexComplementPaymentService';
import { IndexCreditNotesService } from '../views/invoice/IndexCreditNotesService';
import { IndexService } from '../views/configuraciones/services/IndexService';
import { IndexSurvey } from '../views/InformedConsent/IndexSurvey';
import { IndexPendingWork } from '../views/admission/viewWorkOrderDay/IndexPendingWork';
import { IndexCatalogDiscountExams } from '../views/discounts/IndexCatalogDiscountExams';
import { IndexReportBalance } from '../views/reports/cxc/IndexReportBalance';
import { IndexPendingExternaLab } from '../views/externalLaboratory/IndexPendingExternaLab';
import { IndexReportLogs } from '../views/admission/Bi/IndexReportLogs';
import { IndexReportCancell } from '../views/admission/Bi/IndexReportCancell';
import { IndexReportDevolutions } from '../views/admission/Bi/IndexReportDevolutions';
import { IndexReportDiscounts } from '../views/admission/Bi/IndexReportDiscounts';
import { IndexReportSamplesPending } from '../views/admission/Bi/IndexReportSamplesPending';
import { IndexTimeCurves } from '../views/catalog/timeCurves/IndexTimeCurves';
import { IndexMassPrintingResults } from '../views/admission/viewWorkOrderDay/IndexMassPrintingResults';
import { IndexReportLogsExam } from '../views/admission/Bi/IndexReportLogsExam';
import { IndexReportCompany } from '../views/admission/Bi/IndexReportCompany';
import { IndexReportGlobal } from '../views/cash/IndexReportGlobal';
import { IndexReportCreditPending } from '../views/admission/Bi/IndexReportCreditPending';
import { IndexReportServices } from '../views/admission/Bi/IndexReportServices';
import { IndexReportStudiesPatients } from '../views/admission/Bi/IndexReportStudiesPatients';
import { IndexOverdueInvoices } from '../views/reports/cxc/IndexOverdueInvoices';
import { IndexPbi10 } from '../views/admission/Bi/IndexPbi10';
import { IndexQuoterClinics } from '../views/quoter/IndexQuoterClinics';
import { IndexTemplateSurvey } from '../views/templateSurvey/IndexTemplateSurvey';
import { IndexListTemplateSurvey } from '../views/templateSurvey/IndexListTemplateSurvey';
import { IndexReportExamsIncomplete } from '../views/disenio/report/IndexReportExamsIncomplete';
import { IndexDashboardNonConforming } from '../views/reports/cxc/IndexDashboardNonConforming';
import { IndexQualityControL } from '../views/reports/cxc/IndexQualityControL';
import { IndexReportGlobalCxc } from '../views/reports/cxc/IndexReportGlobalCxc';
import { IndexReportShippingDownloads } from '../views/admission/Bi/IndexReportShippingDownloads';
export const routes = [

        // * Dashbaord
        { path: `${process.env.PUBLIC_URL}/dashboard/default/`, Component: Default },

        // * BI
        { path: `${process.env.PUBLIC_URL}/Pbi/1`, Component: IndexPbi1 },
        { path: `${process.env.PUBLIC_URL}/Pbi/2`, Component: IndexPbi2 },
        { path: `${process.env.PUBLIC_URL}/Pbi/3`, Component: IndexPbi3 },
        { path: `${process.env.PUBLIC_URL}/Pbi/4`, Component: IndexPbi4 },
        { path: `${process.env.PUBLIC_URL}/Pbi/5`, Component: IndexPbi5 },
        { path: `${process.env.PUBLIC_URL}/Pbi/6`, Component: IndexPbi6 },
        { path: `${process.env.PUBLIC_URL}/Pbi/7`, Component: IndexPbi7 },
        { path: `${process.env.PUBLIC_URL}/Pbi/8`, Component: IndexPbi8 },
        { path: `${process.env.PUBLIC_URL}/Pbi/9`, Component: IndexPbi9 },
        { path: `${process.env.PUBLIC_URL}/Pbi/10`, Component: IndexPbi10 },


        // * Admission of patient and quoter
        { path: `${process.env.PUBLIC_URL}/admisiones/registro/`, Component: IndexWorkOrder },
        { path: `${process.env.PUBLIC_URL}/admisiones/:id_work_order/editar`, Component: IndexWorkOrder },
        { path: `${process.env.PUBLIC_URL}/dashboard/Cotizador`, Component: IndexQuoterClinics },
        { path: `${process.env.PUBLIC_URL}/admisiones/:id_work_order/editar/:idNotifications`, Component: IndexWorkOrder },
        { path: `${process.env.PUBLIC_URL}/quatation/nueva-cotizacion/:methodd`, Component: IndexQuoter },

        // * Views Work Order Day
        { path: `${process.env.PUBLIC_URL}/busqueda/trabajo-dia`, Component: IndexWorkOrderDay },
        { path: `${process.env.PUBLIC_URL}/busqueda/hojas-trabajo-dia`, Component: IndexWorkSheetsDay },
        { path: `${process.env.PUBLIC_URL}/busqueda/doble-validacion`, Component: IndexDoubleValidation },
        { path: `${process.env.PUBLIC_URL}/busqueda/:id_work_order/detalle-orden`, Component: IndexViewDetailWorkOrder },
        { path: `${process.env.PUBLIC_URL}/busqueda/trabajo-pendiente`, Component: IndexPendingWork },
        { path: `${process.env.PUBLIC_URL}/busqueda/impresion-resultados`, Component: IndexMassPrintingResults },
        { path: `${process.env.PUBLIC_URL}/captura-resultados/:nim`, Component: CaptureResultsFromNim },
        { path: `${process.env.PUBLIC_URL}/captura-resultados-sanitaria/:nim`, Component: CaptureResultsFromNimMicro },

        // * Catalogs
        { path: `${process.env.PUBLIC_URL}/catalogos/pacientes/`, Component: IndexPatient },
        { path: `${process.env.PUBLIC_URL}/catalogos/clientes/`, Component: IndexCompanies },
        { path: `${process.env.PUBLIC_URL}/catalogos/medicos/`, Component: IndexDoctors },
        { path: `${process.env.PUBLIC_URL}/catalogos/laboratoriesExternal`, Component: IndexLaboratories },
        { path: `${process.env.PUBLIC_URL}/catalogos/:laboratoriesId/asignar-examen`, Component: IndexUpdateLaboratories },
        { path: `${process.env.PUBLIC_URL}/catalogos/vendedores/`, Component: IndexSeller },
        { path: `${process.env.PUBLIC_URL}/catalogos/tiempos/`, Component: IndexTimeCurves },

        // * Agreements
        { path: `${process.env.PUBLIC_URL}/convenios`, Component: IndexAgreements },
        { path: `${process.env.PUBLIC_URL}/convenios/nuevo-convenio`, Component: IndexAddAgreement },
        { path: `${process.env.PUBLIC_URL}/convenios/:agreementId/editar-convenio`, Component: IndexAddAgreement },

        // * Design of exams and profiles
        { path: `${process.env.PUBLIC_URL}/diseno/examenes`, Component: IndexExams },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/:examId/metodos`, Component: IndexExamMethod },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/:examId/analitos`, Component: CreateOrUpdateAnalytes },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/:examId/precios`, Component: IndexExamProductionCost },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/simple/:examEditId`, Component: CreateExamSimple },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/simple`, Component: CreateExamSimple },
        { path: `${process.env.PUBLIC_URL}/diseno/perfiles`, Component: IndexProfile },
        { path: `${process.env.PUBLIC_URL}/diseno/nuevo-perfil/:methodd`, Component: IndexPriceExam },
        { path: `${process.env.PUBLIC_URL}/diseno/:profilesId/editar-perfil/:methodd`, Component: IndexPriceExam },
        { path: `${process.env.PUBLIC_URL}/diseno/:profilesId/costs`, Component: CostsProfile },
        { path: `${process.env.PUBLIC_URL}/diseno/:profilesId/global`, Component: GlobalReferenceValues },
        { path: `${process.env.PUBLIC_URL}/diseno/analitos`, Component: IndexAnalytes },
        { path: `${process.env.PUBLIC_URL}/diseno/report/exams/incomplete`, Component: IndexReportExamsIncomplete },

        // * Configurations 
        { path: `${process.env.PUBLIC_URL}/configuraciones/unidades/`, Component: IndexUnit },
        { path: `${process.env.PUBLIC_URL}/configuraciones/textos-precodificados/`, Component: IndexPrecodedText },
        { path: `${process.env.PUBLIC_URL}/configuraciones/sucursales/`, Component: IndexBranch },
        { path: `${process.env.PUBLIC_URL}/configuraciones/:rateId/precios`, Component: IndexPrices },
        { path: `${process.env.PUBLIC_URL}/configuraciones/tarifario`, Component: IndexRates },
        { path: `${process.env.PUBLIC_URL}/configuraciones/puntos-impresion`, Component: IndexPrinterPoints },
        { path: `${process.env.PUBLIC_URL}/configuraciones/especimenes`, Component: IndexSpecimens },
        { path: `${process.env.PUBLIC_URL}/configuraciones/secciones`, Component: IndexSections },
        { path: `${process.env.PUBLIC_URL}/configuraciones/transportes`, Component: IndexTransportsRacks },
        { path: `${process.env.PUBLIC_URL}/configuraciones/especimenes`, Component: IndexSpecimens },
        { path: `${process.env.PUBLIC_URL}/configuraciones/razon-social`, Component: IndexCommercialLines },
        { path: `${process.env.PUBLIC_URL}/configuraciones/razon-social/configuracion-folios/:idBranch`, Component: InvoiceSettings },
        { path: `${process.env.PUBLIC_URL}/configuraciones/metodos-pago`, Component: IndexPayMethods },
        { path: `${process.env.PUBLIC_URL}/configuraciones/margen-minimo`, Component: IndexProfit },
        { path: `${process.env.PUBLIC_URL}/configuraciones/usuarios`, Component: IndexUser },
        { path: `${process.env.PUBLIC_URL}/configuraciones/indicaciones`, Component: IndexIndications },
        { path: `${process.env.PUBLIC_URL}/configuraciones/tiempos-curvas`, Component: IndexCurvesTimes },
        { path: `${process.env.PUBLIC_URL}/configuraciones/interfaz-analizador`, Component: IndexAnalyzerInterface },
        { path: `${process.env.PUBLIC_URL}/configuraciones/logs`, Component: Indexlog },
        { path: `${process.env.PUBLIC_URL}/configuraciones/roles`, Component: IndexUserRole },
        { path: `${process.env.PUBLIC_URL}/configuraciones/servicios`, Component: IndexService },
        { path: `${process.env.PUBLIC_URL}/configuraciones/:rateId/costos`, Component: IndexCost },
        { path: `${process.env.PUBLIC_URL}/maquilaInterna/:branchId`, Component: IndexConfigExams },
        { path: `${process.env.PUBLIC_URL}/control/calidad`, Component: IndexQualityControL },



        // * Discounts 
        { path: `${process.env.PUBLIC_URL}/descuentos/especiales`, Component: IndexSpecialDiscount },
        { path: `${process.env.PUBLIC_URL}/descuentos/campañas`, Component: IndexCommonDiscount },
        { path: `${process.env.PUBLIC_URL}/catalogo/descuentos`, Component: IndexCatalogsDiscounts },
        { path: `${process.env.PUBLIC_URL}/descuentos/examenes`, Component: IndexCatalogDiscountExams },

        // * Balance and reports
        { path: `${process.env.PUBLIC_URL}/balance/corte/:User`, Component: IndexCash },
        { path: `${process.env.PUBLIC_URL}/reportes/cxc`, Component: IndexReportCxc },
        { path: `${process.env.PUBLIC_URL}/deposits/reports`, Component: IndexBankingDeposits },
        { path: `${process.env.PUBLIC_URL}/Reporte/:Admin`, Component: IndexReportGlobal },
        { path: `${process.env.PUBLIC_URL}/Report/global`, Component: IndexCashFlowGlobal },

        { path: `${process.env.PUBLIC_URL}/reportes/credito-cobranza`, Component: IndexReportBalance },

        { path: `${process.env.PUBLIC_URL}/facturas/vencidas`, Component: IndexOverdueInvoices },
        { path: `${process.env.PUBLIC_URL}/reportes/global/cxc`, Component: IndexReportGlobalCxc },

        // * Invoice routes
        { path: `${process.env.PUBLIC_URL}/invoice/service`, Component: IndexInvoiceService },
        { path: `${process.env.PUBLIC_URL}/facturacion/Emitidos`, Component: IndexViewInvoice },
        { path: `${process.env.PUBLIC_URL}/facturacion/complemento-pago`, Component: IndexComplementPaymentService },
        { path: `${process.env.PUBLIC_URL}/facturacion/notas-credito`, Component: IndexCreditNotesService },
        { path: `${process.env.PUBLIC_URL}/invoice/:id_work_order_r/:id_patient_r/:_id_company_r/service`, Component: IndexInvoiceService },
        { path: `${process.env.PUBLIC_URL}/invoice/service/:request_id_invoice`, Component: IndexInvoiceService },
        //{ path: `${process.env.PUBLIC_URL}/facturacion/reporte`, Component: IndexInvoiceReport },

        // * new
        { path: `${process.env.PUBLIC_URL}/facturacion/complemento-pago/:idCompany/:idInvoice`, Component: IndexComplementPaymentService },
        //history.push(`../facturacion/complemento-pago?company=${idCompany}`);






        // * Informed Consent
        { path: `${process.env.PUBLIC_URL}/consentimiento-informado`, Component: IndexInformedConsent },
        { path: `${process.env.PUBLIC_URL}/satisfaction/consentimiento`, Component: IndexSatisfaction },
        { path: `${process.env.PUBLIC_URL}/satisfaction/encuestas`, Component: IndexSurvey },
        { path: `${process.env.PUBLIC_URL}/listado/de/Consentimientos`, Component: IndexListTemplateSurvey },
        { path: `${process.env.PUBLIC_URL}/plantillas`, Component: IndexTemplateSurvey },
        { path: `${process.env.PUBLIC_URL}/plantillas/:idTemplate/editar`, Component: IndexTemplateSurvey },




        // * Microbiology
        { path: `${process.env.PUBLIC_URL}/micro/bacterium`, Component: IndexBacter },
        { path: `${process.env.PUBLIC_URL}/micro/morpholgy`, Component: IndexMorphology },
        { path: `${process.env.PUBLIC_URL}/micro/antibiotic`, Component: IndexAntibiotic },
        { path: `${process.env.PUBLIC_URL}/micro/antibiogram`, Component: IndexAntibiogram },
        { path: `${process.env.PUBLIC_URL}/micro/cultivo`, Component: IndexCulture },
        { path: `${process.env.PUBLIC_URL}/micro/diseno/:examId/analitos`, Component: CreateExam },
        { path: `${process.env.PUBLIC_URL}/micro/resistanceMechanism`, Component: IndexResistanceMechanism },
        { path: `${process.env.PUBLIC_URL}/micro/stainGrams`, Component: IndexStainGrams },
        { path: `${process.env.PUBLIC_URL}/micro/bacteriumCount`, Component: IndexBacteriumCountText },
        { path: `${process.env.PUBLIC_URL}/micro/tincion`, Component: IndexStain },
        { path: `${process.env.PUBLIC_URL}/micro/tincionResult`, Component: IndexStainResults },
        { path: `${process.env.PUBLIC_URL}/micro/Reporte-Positividad`, Component: IndexReportMicStatistics },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/:examId/metodos`, Component: IndexExamMethod },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/Micro`, Component: IndexExamsMicrobiology },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/Micro/:examId/precios`, Component: IndexExamProductionCostMicrobiology },
        { path: `${process.env.PUBLIC_URL}/diseno/examenes/:examId/metodos/Micro`, Component: IndexExamMethodMicrobiology },

        // * REPORTES 
        { path: `${process.env.PUBLIC_URL}/Reportes/Pacientes`, Component: IndexReportLogs },
        { path: `${process.env.PUBLIC_URL}/Reportes/pendiente-laboratorio-referencia`, Component: IndexPendingExternaLab },
        { path: `${process.env.PUBLIC_URL}/Reportes/Cancelaciones`, Component: IndexReportCancell },
        { path: `${process.env.PUBLIC_URL}/Reportes/Devoluciones`, Component: IndexReportDevolutions },
        { path: `${process.env.PUBLIC_URL}/Reportes/Descuentos`, Component: IndexReportDiscounts },
        { path: `${process.env.PUBLIC_URL}/Reportes/Muestras-Pendientes`, Component: IndexReportSamplesPending },
        { path: `${process.env.PUBLIC_URL}/Reportes/Logs-Examenes`, Component: IndexReportLogsExam },
        { path: `${process.env.PUBLIC_URL}/Reportes/Empresas`, Component: IndexReportCompany },
        { path: `${process.env.PUBLIC_URL}/Reportes/Creditos-Pendientes`, Component: IndexReportCreditPending },
        { path: `${process.env.PUBLIC_URL}/Reportes/Servicios`, Component: IndexReportServices },
        { path: `${process.env.PUBLIC_URL}/Reportes/Historico-Pacientes`, Component: IndexReportStudiesPatients },
        { path: `${process.env.PUBLIC_URL}/Reportes/Muestras-no-conformes`, Component: IndexDashboardNonConforming },
        { path: `${process.env.PUBLIC_URL}/Reportes/envios-impresiones`, Component: IndexReportShippingDownloads },



        // * SANITARIA
        { path: `${process.env.PUBLIC_URL}/sanitaria/sitios`, Component: IndexSites },
        { path: `${process.env.PUBLIC_URL}/sanitaria/muestras`, Component: IndexMicSample },
        { path: `${process.env.PUBLIC_URL}/sanitaria/areas`, Component: IndexMicSiteArea },
        { path: `${process.env.PUBLIC_URL}/sanitaria/normas`, Component: IndexMicCatalogs },
        { path: `${process.env.PUBLIC_URL}/sanitaria/cotizacion`, Component: IndexTabMenuQuoter },
        { path: `${process.env.PUBLIC_URL}/sanitaria/tipo-muestra`, Component: IndexTypeSample },
        { path: `${process.env.PUBLIC_URL}/sanitaria/agenda`, Component: IndexMicDiary },
        { path: `${process.env.PUBLIC_URL}/sanitaria/muestreo/:code_Quatation`, Component: IndexMicSampling },
        //{ path: `${process.env.PUBLIC_URL}/cierre/global`, Component: IndexCashFlowGlobal },
        { path: `${process.env.PUBLIC_URL}/configuraciones/catalogos`, Component: IndexReturnReason },
        { path: `${process.env.PUBLIC_URL}/sanitaria/cotizacion-micro`, Component: IndexMicroQuoter },
        { path: `${process.env.PUBLIC_URL}/sanitaria/lista-hojas-muestreo`, Component: IndexListSampligs },
        { path: `${process.env.PUBLIC_URL}/sanitaria/cat_equipos_sanitaria`, Component: IndexListMachinesSanitary },
        { path: `${process.env.PUBLIC_URL}/sanitaria/cat_lote_medios_sanitaria`, Component: IndexListLot },
        { path: `${process.env.PUBLIC_URL}/sanitaria/hojas_trabajo_sanitary`, Component: IndexWorkSheetSanitary },
        { path: `${process.env.PUBLIC_URL}/sanitaria/captura_hojas_trabajo_sanitaria/:idDetailMicSample`, Component: IndexCaptureWorkSheetSanitary },
        { path: `${process.env.PUBLIC_URL}/sanitaria/sanitaria_reports`, Component: IndexReportsSanitary },
        { path: `${process.env.PUBLIC_URL}/sanitaria/creacion_hojas_trabajo_sanitary`, Component: IndexCreateWorkSheetSaniray },
        { path: `${process.env.PUBLIC_URL}/sanitaria/creacion_procesos/:idwsconfigProcess`, Component: CreateWSProcess },
        { path: `${process.env.PUBLIC_URL}/sanitaria/sanitaria_recepcion_muestras`, Component: IndexSampleReception },
        { path: `${process.env.PUBLIC_URL}/sanitaria/contenedores`, Component: IndexMicContainers },
        { path: `${process.env.PUBLIC_URL}/sanitaria/estatus`, Component: IndexMicEstatus },
        { path: `${process.env.PUBLIC_URL}/sanitaria/razones_rechazo`, Component: IndexMicReturnReasons },
        { path: `${process.env.PUBLIC_URL}/sanitaria/unidades_medida`, Component: IndexMicUnits },
        { path: `${process.env.PUBLIC_URL}/sanitaria/termometros`, Component: IndexMicThermometer },
        { path: `${process.env.PUBLIC_URL}/sanitaria/recepcion/:_nim`, Component: IndexSampleReception },
        { path: `${process.env.PUBLIC_URL}/sanitaria/caracteristicas`, Component: IndexMicCharacteristic },

        // * FINANCE 
        { path: `${process.env.PUBLIC_URL}/visualizador/calender`, Component: IndexViewCalender },
        { path: `${process.env.PUBLIC_URL}/visualizador/:_start_date/:_end_date/calender`, Component: IndexViewCalender },

]